var _rect, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyDatagrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-285"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 435.43,
    rx: 174.67,
    ry: 20.81,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.3,
    cy: 394.03,
    rx: 153.1,
    ry: 20.81,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-285"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.02 340.24 89.4 340 142.79 339.91 249.55 339.74 356.32 339.91 409.7 339.99 463.08 340.24 409.7 340.48 356.32 340.57 249.55 340.74 142.79 340.57 89.4 340.48 36.02 340.24",
    style: {
      fill: "#cfcfcf"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folders--inject-285"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.8,
    y: 234.49,
    width: 235.88,
    height: 171.33,
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.47 216.74 140.9 216.74 140.88 234.49 233.49 234.49 228.47 216.74",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.2,
    y: 206.46,
    width: 167.98,
    height: 219.16,
    transform: "translate(-60.85 571.23) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.77,232.05l.06,168v.06h-.06l-219.16.08h-.14V400l.06-168V232h.08Zm0,0-219.16.08.08-.08.06,168-.14-.14,219.16.08-.06.06Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.17,
    y: 313.42,
    width: 167.98,
    height: 5.23,
    transform: "translate(46.12 678.2) rotate(-90)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.46,
    y: 334.24,
    width: 12.16,
    height: 107.41,
    transform: "translate(-183.41 592.49) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.8,
    y: 190.42,
    width: 12.16,
    height: 107.41,
    transform: "translate(61.76 550.01) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.23,
    y: 313.42,
    width: 167.98,
    height: 5.23,
    transform: "translate(-167.82 464.26) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.66,
    y: 285.51,
    width: 61.06,
    height: 61.06,
    transform: "translate(-99.85 532.23) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.96,
    cy: 316.04,
    r: 12.24,
    transform: "translate(-25.41 18.27) rotate(-4.74)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.74,294.89h5v42.3h-5a21.15,21.15,0,1,1,0-42.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.86,
    y: 307.58,
    width: 144.09,
    height: 16.92,
    transform: "translate(-148.13 483.94) rotate(-90)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 373.08,
    width: 28.1,
    height: 1.9,
    transform: "translate(-187.42 560.64) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.2,
    y: 373.08,
    width: 28.1,
    height: 1.9,
    transform: "translate(-115.78 632.28) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.25,
    y: 373.08,
    width: 28.1,
    height: 1.9,
    transform: "translate(-39.73 708.33) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.56,
    y: 373.08,
    width: 28.1,
    height: 1.9,
    transform: "translate(-70.42 677.64) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 265.06,
    width: 28.1,
    height: 1.9,
    transform: "translate(-79.41 452.62) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.18,388.08c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l0,9,0,9C192.31,382.07,192.27,385.08,192.18,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.78,388.08c-.09-3-.13-6-.17-9l0-9,0-9c0-3,.08-6,.17-9,.08,3,.12,6,.16,9l.05,9-.05,9C194.9,382.07,194.86,385.08,194.78,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.37,388.08c-.08-3-.12-6-.16-9l-.05-9,.05-9q0-4.51.16-9c.09,3,.13,6,.16,9l.05,9-.05,9C197.5,382.07,197.46,385.08,197.37,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,388.08c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C200.1,382.07,200.06,385.08,200,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.57,388.08c-.09-1.5-.13-3-.16-4.51s0-3,0-4.51,0-3,0-4.51.07-3,.16-4.5c.08,1.5.12,3,.16,4.5s0,3,.05,4.51,0,3-.05,4.51S202.65,386.58,202.57,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.76,388.08c-.09-3-.13-6-.16-9l0-9,0-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C207.89,382.07,207.85,385.08,207.76,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.36,388.08c-.09-3-.13-6-.16-9l0-9,0-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l0,9,0,9C210.49,382.07,210.45,385.08,210.36,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,388.08c-.09-3-.13-6-.17-9l0-9,0-9c0-3,.08-6,.17-9,.08,3,.12,6,.16,9l0,9,0,9C213.08,382.07,213,385.08,213,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.55,388.08c-.08-3-.12-6-.16-9l0-9,0-9c0-3,.08-6,.16-9,.09,3,.13,6,.17,9l0,9,0,9C215.68,382.07,215.64,385.08,215.55,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.15,388.08c-.09-1.5-.13-3-.16-4.51s0-3-.05-4.51,0-3,.05-4.51.07-3,.16-4.5c.09,1.5.13,3,.16,4.5s0,3,.05,4.51,0,3-.05,4.51S218.24,386.58,218.15,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.34,388.08c-.08-3-.12-6-.16-9l-.05-9,.05-9c0-3,.08-6,.16-9,.09,3,.13,6,.17,9l.05,9-.05,9C223.47,382.07,223.43,385.08,223.34,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.94,388.08q-.12-4.5-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C226.07,382.07,226,385.08,225.94,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.54,388.08c-.09-3-.13-6-.16-9l0-9,0-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C228.67,382.07,228.63,385.08,228.54,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.14,388.08c-.09-1.5-.13-3-.16-4.51s0-3,0-4.51,0-3,0-4.51.08-3,.17-4.5c.08,1.5.12,3,.16,4.5s0,3,0,4.51,0,3,0,4.51S231.22,386.58,231.14,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.33,388.08c-.09-3-.13-6-.16-9l0-9,0-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l0,9,0,9C236.46,382.07,236.42,385.08,236.33,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.93,388.08c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l0,9,0,9Q239,383.58,238.93,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.53,388.08c-.09-3-.13-6-.17-9l-.05-9,.05-9c0-3,.08-6,.17-9,.08,3,.12,6,.16,9l.05,9-.05,9C241.65,382.07,241.61,385.08,241.53,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.12,388.08q-.12-4.5-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C244.25,382.07,244.21,385.08,244.12,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72,388.08c-.09-1.5-.13-3-.16-4.51s0-3-.05-4.51,0-3,.05-4.51.07-3,.16-4.5c.09,1.5.13,3,.16,4.5s0,3,.05,4.51,0,3-.05,4.51S246.81,386.58,246.72,388.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.18,280.07c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l0,9,0,9C192.31,274.05,192.27,277.06,192.18,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.78,280.07c-.09-3-.13-6-.17-9l0-9,0-9c0-3,.08-6,.17-9,.08,3,.12,6,.16,9l.05,9-.05,9C194.9,274.05,194.86,277.06,194.78,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.37,280.07c-.08-3-.12-6-.16-9l-.05-9,.05-9q0-4.5.16-9c.09,3,.13,6,.16,9l.05,9-.05,9C197.5,274.05,197.46,277.06,197.37,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,280.07c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C200.1,274.05,200.06,277.06,200,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.57,280.07c-.09-1.51-.13-3-.16-4.51s0-3,0-4.51,0-3,0-4.51.07-3,.16-4.51c.08,1.5.12,3,.16,4.51s0,3,.05,4.51,0,3-.05,4.51S202.65,278.56,202.57,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.76,280.07c-.09-3-.13-6-.16-9l0-9,0-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C207.89,274.05,207.85,277.06,207.76,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.36,280.07c-.09-3-.13-6-.16-9l0-9,0-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l0,9,0,9C210.49,274.05,210.45,277.06,210.36,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,280.07c-.09-3-.13-6-.17-9l0-9,0-9c0-3,.08-6,.17-9,.08,3,.12,6,.16,9l0,9,0,9C213.08,274.05,213,277.06,213,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.55,280.07c-.08-3-.12-6-.16-9l0-9,0-9c0-3,.08-6,.16-9,.09,3,.13,6,.17,9l0,9,0,9C215.68,274.05,215.64,277.06,215.55,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.15,280.07c-.09-1.51-.13-3-.16-4.51s0-3-.05-4.51,0-3,.05-4.51.07-3,.16-4.51c.09,1.5.13,3,.16,4.51s0,3,.05,4.51,0,3-.05,4.51S218.24,278.56,218.15,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.34,280.07c-.08-3-.12-6-.16-9l-.05-9,.05-9c0-3,.08-6,.16-9,.09,3,.13,6,.17,9l.05,9-.05,9C223.47,274.05,223.43,277.06,223.34,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.94,280.07q-.12-4.51-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C226.07,274.05,226,277.06,225.94,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.54,280.07c-.09-3-.13-6-.16-9l0-9,0-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C228.67,274.05,228.63,277.06,228.54,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.14,280.07c-.09-1.51-.13-3-.16-4.51s0-3,0-4.51,0-3,0-4.51.08-3,.17-4.51c.08,1.5.12,3,.16,4.51s0,3,0,4.51,0,3,0,4.51S231.22,278.56,231.14,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.33,280.07c-.09-3-.13-6-.16-9l0-9,0-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l0,9,0,9C236.46,274.05,236.42,277.06,236.33,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.93,280.07c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l0,9,0,9Q239,275.55,238.93,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.53,280.07c-.09-3-.13-6-.17-9l-.05-9,.05-9c0-3,.08-6,.17-9,.08,3,.12,6,.16,9l.05,9-.05,9C241.65,274.05,241.61,277.06,241.53,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.12,280.07q-.12-4.51-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C244.25,274.05,244.21,277.06,244.12,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72,280.07c-.09-1.51-.13-3-.16-4.51s0-3-.05-4.51,0-3,.05-4.51.07-3,.16-4.51c.09,1.5.13,3,.16,4.51s0,3,.05,4.51,0,3-.05,4.51S246.81,278.56,246.72,280.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.62,
    y: 350.09,
    width: 56.59,
    height: 2.63,
    transform: "translate(-84.5 618.31) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.45,
    y: 357.93,
    width: 40.91,
    height: 2.63,
    transform: "translate(-92.33 626.15) rotate(-90)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.41,
    y: 350.09,
    width: 56.59,
    height: 2.63,
    transform: "translate(-77.7 625.11) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.76,
    y: 352.44,
    width: 51.89,
    height: 2.63,
    transform: "translate(-80.05 627.46) rotate(-90)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.21,
    y: 350.09,
    width: 56.59,
    height: 2.63,
    transform: "translate(-70.9 631.91) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.45,
    y: 356.34,
    width: 44.1,
    height: 2.63,
    transform: "translate(-77.15 638.15) rotate(-90)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.01,
    y: 350.09,
    width: 56.59,
    height: 2.63,
    transform: "translate(-64.11 638.71) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.99,
    y: 354.07,
    width: 48.63,
    height: 2.63,
    transform: "translate(-68.08 642.68) rotate(-90)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: 350.09,
    width: 56.59,
    height: 2.63,
    transform: "translate(-57.31 645.5) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 351.77,
    width: 53.22,
    height: 2.63,
    transform: "translate(-58.99 647.19) rotate(-90)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.79,
    y: 383.84,
    width: 4.24,
    height: 4.24,
    transform: "translate(-119.05 652.87) rotate(-90)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.58,
    y: 383.84,
    width: 4.24,
    height: 4.24,
    transform: "translate(-112.25 659.67) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.38,
    y: 383.84,
    width: 4.24,
    height: 4.24,
    transform: "translate(-105.46 666.46) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.18,
    y: 383.84,
    width: 4.24,
    height: 4.24,
    transform: "translate(-98.66 673.26) rotate(-90)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.98,
    y: 383.84,
    width: 4.24,
    height: 4.24,
    transform: "translate(-91.86 680.06) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.22,
    y: 288.86,
    width: 36.06,
    height: 1.9,
    transform: "translate(-31.56 548.06) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.78,
    y: 300.03,
    width: 13.71,
    height: 1.9,
    transform: "translate(-35.35 566.62) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.96,
    y: 300.03,
    width: 13.71,
    height: 1.9,
    transform: "translate(-19.17 582.8) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.15,
    y: 300.03,
    width: 13.71,
    height: 1.9,
    transform: "translate(-2.98 598.99) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 300.03,
    width: 13.71,
    height: 1.9,
    transform: "translate(13.2 615.17) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.63,280.16c-.08-3-.12-6-.16-9l-.05-9,.05-9c0-3,.08-6,.16-9,.09,3,.13,6,.16,9l0,9,0,9C265.76,274.14,265.72,277.15,265.63,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.23,280.16c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C268.36,274.14,268.32,277.15,268.23,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.83,280.16c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.08,3,.13,6,.16,9l.05,9-.05,9C271,274.14,270.91,277.15,270.83,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.42,280.16c-.08-1.27-.12-2.54-.16-3.81s0-2.54-.05-3.81,0-2.54.05-3.81.08-2.54.16-3.81c.09,1.27.13,2.54.17,3.81s0,2.54,0,3.81,0,2.54,0,3.81S273.51,278.89,273.42,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.86,280.16c-.08-3-.12-6-.16-9l-.05-9,.05-9c0-3,.08-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C282,274.14,282,277.15,281.86,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.46,280.16c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C284.59,274.14,284.55,277.15,284.46,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.06,280.16c-.09-3-.13-6-.16-9l0-9,0-9c0-3,.07-6,.16-9,.08,3,.13,6,.16,9l0,9,0,9C287.18,274.14,287.14,277.15,287.06,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.65,280.16c-.08-1.27-.12-2.54-.16-3.81s0-2.54-.05-3.81,0-2.54.05-3.81.08-2.54.16-3.81c.09,1.27.13,2.54.17,3.81s0,2.54,0,3.81,0,2.54,0,3.81S289.74,278.89,289.65,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.09,280.16q-.12-4.52-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C298.22,274.14,298.18,277.15,298.09,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.69,280.16c-.09-3-.13-6-.16-9l0-9,0-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l0,9,0,9C300.82,274.14,300.78,277.15,300.69,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.29,280.16c-.09-3-.13-6-.16-9l-.05-9,0-9c0-3,.08-6,.17-9,.08,3,.12,6,.16,9l.05,9-.05,9C303.41,274.14,303.37,277.15,303.29,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.88,280.16c-.08-1.27-.12-2.54-.16-3.81s0-2.54-.05-3.81,0-2.54.05-3.81.08-2.54.16-3.81c.09,1.27.13,2.54.17,3.81s0,2.54,0,3.81,0,2.54,0,3.81S306,278.89,305.88,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.32,280.16q-.12-4.52-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l0,9,0,9C314.45,274.14,314.41,277.15,314.32,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.92,280.16c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C317.05,274.14,317,277.15,316.92,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.52,280.16c-.09-3-.13-6-.16-9l-.05-9,0-9c0-3,.08-6,.17-9,.08,3,.12,6,.16,9l.05,9-.05,9C319.64,274.14,319.6,277.15,319.52,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.11,280.16c-.08-1.27-.12-2.54-.16-3.81s0-2.54-.05-3.81,0-2.54.05-3.81.08-2.54.16-3.81c.09,1.27.13,2.54.17,3.81s0,2.54,0,3.81,0,2.54-.05,3.81S322.2,278.89,322.11,280.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.99 287.38 273.18 287.27 281.38 287.21 297.77 287.16 298.77 287.21 306.97 287.27 315.17 287.38 306.97 287.49 298.77 287.55 297.77 287.6 281.38 287.55 273.18 287.49 264.99 287.38",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.63,
    cy: 287.38,
    r: 0.84,
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.86,286.54a.84.84,0,0,1,.85.84.85.85,0,1,1-1.69,0A.84.84,0,0,1,281.86,286.54Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.09,
    cy: 287.38,
    r: 0.84,
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.32,
    cy: 287.38,
    r: 0.84,
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,375.57a6.24,6.24,0,1,1-3.11.82A6.25,6.25,0,0,1,315.86,375.57Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,376.39l3.11,5.43H309.6A6.24,6.24,0,0,1,312.75,376.39Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,377.5a4.33,4.33,0,1,1-4.33,4.32A4.31,4.31,0,0,1,315.86,377.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.35,
    y: 381.57,
    width: 3.6,
    height: 0.51,
    transform: "translate(-66.68 696.97) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.87,
    y: 381.57,
    width: 5.39,
    height: 0.51,
    transform: "translate(-65.26 698.39) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,358.06a5.49,5.49,0,0,1,.91.07,6.23,6.23,0,1,1-.91-.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,358.06a5.49,5.49,0,0,1,.91.07l-.91,6.18H309.6a6.24,6.24,0,0,1,6.26-6.25Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,360a4.33,4.33,0,1,1-4.33,4.32A4.31,4.31,0,0,1,315.86,360Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.35,
    y: 364.06,
    width: 3.6,
    height: 0.51,
    transform: "translate(-49.17 679.46) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.87,
    y: 364.06,
    width: 5.39,
    height: 0.51,
    transform: "translate(-47.75 680.88) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,340.43a6.25,6.25,0,0,1,5.84,4,6.19,6.19,0,0,1,.41,2.24,6.26,6.26,0,1,1-6.25-6.25Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,340.43a6.25,6.25,0,0,1,5.84,4l-5.84,2.24H309.6a6.24,6.24,0,0,1,6.26-6.25Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,342.36a4.33,4.33,0,1,1-4.33,4.32A4.31,4.31,0,0,1,315.86,342.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.35,
    y: 346.43,
    width: 3.6,
    height: 0.51,
    transform: "translate(-31.53 661.83) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.87,
    y: 346.43,
    width: 5.39,
    height: 0.51,
    transform: "translate(-30.12 663.25) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,322.89a6.27,6.27,0,1,1-3.11.83A6.15,6.15,0,0,1,315.86,322.89Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,322.89a6.26,6.26,0,0,1,4.75,10.32l-4.75-4.06H309.6a6.24,6.24,0,0,1,3.15-5.43A6.15,6.15,0,0,1,315.86,322.89Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,324.82a4.33,4.33,0,1,1-4.33,4.33A4.32,4.32,0,0,1,315.86,324.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.35,
    y: 328.89,
    width: 3.6,
    height: 0.51,
    transform: "translate(-14 644.3) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.87,
    y: 328.89,
    width: 5.39,
    height: 0.51,
    transform: "translate(-12.59 645.71) rotate(-90)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.16 317.3 265.72 317.19 274.28 317.13 291.4 317.08 308.51 317.13 317.07 317.19 325.63 317.3 317.07 317.4 308.51 317.46 291.4 317.5 274.28 317.46 265.72 317.4 257.16 317.3",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--iaq7yo--inject-285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.89,384.22a.5.5,0,0,1,.14.27l0,.14v.23a2,2,0,0,0,0,.24,2.57,2.57,0,0,1-.38.86,5.54,5.54,0,0,1-1.55,1.54,2.39,2.39,0,0,1-.85.37l-.24,0h-.23a.85.85,0,0,1-.41-.15l0,0,1-1a.07.07,0,0,1,.06,0,.47.47,0,0,0,.47-.1,8.12,8.12,0,0,0,.88-.88.46.46,0,0,0,.11-.47,0,0,0,0,1,0-.06l1-1Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.33,383.65l.34.34,0,0-1,1-.06-.08-.3-.29a.17.17,0,0,1,0-.26l.75-.74A.16.16,0,0,1,343.33,383.65Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.78,386.18l.37.39-1,1,0,0-.35-.35a.15.15,0,0,1,0-.24l.75-.75A.16.16,0,0,1,340.78,386.18Z",
    style: {
      fill: "#efefef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tefye6--inject-285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.94,383.79a.94.94,0,0,1,.1.1l1.59,1.67a.25.25,0,0,1,0,.38L349,387.65l-.07.06a.24.24,0,0,1,0-.15v-1.15c0-.81,0-1.61,0-2.41A.39.39,0,0,1,348.94,383.79Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89,383.79a.89.89,0,0,1,0,.14v1.39c0,.74,0,1.48,0,2.22a.39.39,0,0,1,0,.18l-1.32-1.38.25-.27.11-.11a.3.3,0,0,0,0-.43l-.35-.37,1.29-1.37Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.41,386.51c.44.44.86.9,1.3,1.34h-2.58Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.69,383.65l-.48.5-.77.82,0,0c-.44-.45-.86-.91-1.3-1.34C349.17,383.64,351.63,383.63,351.69,383.65Z",
    style: {
      fill: "#efefef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--aizgp2--inject-285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.8,317.33a2.9,2.9,0,0,0,1,.21v.85h-.09a2,2,0,0,1-.34-.06,2.47,2.47,0,0,1-.52-.18s0,0,0,0v-.79Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,317.36h0v.77s0,0,0,0a2.49,2.49,0,0,1-.6.2l-.3,0h0v-.83s0,0,0,0h.21l.32,0,.39-.12Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2,314.06h0a2,2,0,0,1,.29.22,2.35,2.35,0,0,1,.3.33,2.3,2.3,0,0,1,.23.37,2.26,2.26,0,0,1,.15.39c0,.11.05.22.07.33v0a2.67,2.67,0,0,0-.6-.61,3,3,0,0,0-.42-.26s0,0,0,0v-.8Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.76,314.85V316h-1v-.86s0,0,0,0a2.26,2.26,0,0,1,.56-.17l.31,0Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,314.85h.22l.22,0a2.33,2.33,0,0,1,.47.14l0,0v.87H342Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.8,316.2h1v1.07h-.08l-.16,0-.24-.05a2.06,2.06,0,0,1-.48-.15s0,0,0,0v-.82Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,316.19H343v.86s0,0,0,0a2.13,2.13,0,0,1-.49.15l-.26,0H342v-1.05Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.77,313.68v.9a3.17,3.17,0,0,0-1,.21h0V314s0,0,0,0a2.14,2.14,0,0,1,.6-.21l.34,0Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,313.68h.06l.24,0a2.19,2.19,0,0,1,.55.17l.08,0v.85h0l-.09,0a3.17,3.17,0,0,0-.44-.12c-.11,0-.21,0-.32,0H342Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,314.09h0v.81a2.46,2.46,0,0,0-.58.39,2.68,2.68,0,0,0-.28.3l-.12.17h0a2.47,2.47,0,0,1,.24-.8A2.29,2.29,0,0,1,340.55,314.09Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.24,316.35v0a2.38,2.38,0,0,1-.05.26,2.54,2.54,0,0,1-.17.46,2.47,2.47,0,0,1-.31.46,1.48,1.48,0,0,1-.28.28l-.24.18h0v-.73s0,0,0,0a3.23,3.23,0,0,0,.44-.27,2.66,2.66,0,0,0,.35-.32,3.61,3.61,0,0,0,.25-.3Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.56,316.36l.08.11a2.59,2.59,0,0,0,.86.73l0,0h0V318a2.32,2.32,0,0,1-1-1.62h0Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2,315.17a3,3,0,0,1,.49.37,2.3,2.3,0,0,1,.35.41h-.84Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2,316.2H344a2.45,2.45,0,0,1-.83.74Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,315.2V316h-.79a1.78,1.78,0,0,1,.35-.42A2.41,2.41,0,0,1,340.55,315.2Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.78,316.2h.77v.71A2.28,2.28,0,0,1,339.78,316.2Z",
    style: {
      fill: "#efefef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ugja8c--inject-285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349,314.21a2,2,0,0,0-1.07,2.34,1.88,1.88,0,0,0,2,1.46,2.37,2.37,0,0,0,.87-.26,7.21,7.21,0,0,0,1.65-1.13l.59-.57L353,316c-.26-.24-.52-.5-.79-.73a5.65,5.65,0,0,0-1.68-1.05A2,2,0,0,0,349,314.21Zm.74.61a1.23,1.23,0,1,1-1.25,1.15A1.21,1.21,0,0,1,349.7,314.82Z",
    style: {
      fill: "#efefef"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M340.46,379.22c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C340.59,373.21,340.55,376.22,340.46,379.22Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.06,379.22c-.09-1.5-.13-3-.16-4.51s0-3,0-4.51,0-3,0-4.51.07-3,.16-4.5c.08,1.5.13,3,.16,4.5s0,3,0,4.51,0,3,0,4.51S343.14,377.72,343.06,379.22Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.11,379.22c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C349.24,373.21,349.2,376.22,349.11,379.22Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.71,379.22c-.09-1.5-.13-3-.16-4.51s0-3-.05-4.51,0-3,.05-4.51.07-3,.16-4.5c.08,1.5.13,3,.16,4.5s0,3,.05,4.51,0,3-.05,4.51S351.79,377.72,351.71,379.22Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.46,307.28c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C340.59,301.27,340.55,304.27,340.46,307.28Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.06,307.28c-.09-1.5-.13-3-.16-4.51s0-3,0-4.51,0-3,0-4.51.07-3,.16-4.51c.08,1.5.13,3,.16,4.51s0,3,0,4.51,0,3,0,4.51S343.14,305.78,343.06,307.28Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.11,307.28c-.09-3-.13-6-.16-9l-.05-9,.05-9c0-3,.07-6,.16-9,.09,3,.13,6,.16,9l.05,9-.05,9C349.24,301.27,349.2,304.27,349.11,307.28Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.71,307.28c-.09-1.5-.13-3-.16-4.51s0-3-.05-4.51,0-3,.05-4.51.07-3,.16-4.51c.08,1.5.13,3,.16,4.51s0,3,.05,4.51,0,3-.05,4.51S351.79,305.78,351.71,307.28Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.16 405.81 139.28 405.81 137.51 248.7 373.39 248.7 375.16 405.81",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.91 232.43 137.33 232.43 137.51 248.7 230.12 248.7 224.91 232.43",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.28,
    y: 252.56,
    width: 235.88,
    height: 171.33,
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.96 234.81 84.38 234.81 84.36 252.56 176.97 252.56 171.96 234.81",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.28,
    y: 252.56,
    width: 235.88,
    height: 171.33
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "171.96 234.81 84.38 234.81 84.36 252.56 176.97 252.56 171.96 234.81"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 186.05,
    width: 167.98,
    height: 219.16,
    transform: "translate(-126.61 438.4) rotate(-79.27)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.66,233.52l-31.23,165v.06h-.06L78,357.88l-.14,0,0-.13,31.35-165v-.08h.08Zm0,0L109.32,192.78l.09-.06-31.23,165-.11-.16L293.38,398.5l-.07.05Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.46,
    y: 312.94,
    width: 167.98,
    height: 5.23,
    transform: "translate(-60.66 557.87) rotate(-79.27)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.12,
    y: 303.14,
    width: 12.16,
    height: 107.41,
    transform: "matrix(0.19, -0.98, 0.98, 0.19, -238.15, 426.17)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.47,
    y: 180.71,
    width: 12.16,
    height: 107.41,
    transform: "translate(-15.04 450.68) rotate(-79.27)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.27,
    y: 273.09,
    width: 167.98,
    height: 5.23,
    transform: "translate(-192.55 318.93) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.5,
    y: 257.84,
    width: 61.06,
    height: 61.06,
    transform: "translate(-150.65 394.84) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.95,
    cy: 286.84,
    r: 12.24,
    transform: "translate(-156.15 384.31) rotate(-79.02)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.08,272.34l4.89.93-7.88,41.57-4.89-.93a21.16,21.16,0,1,1,7.88-41.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.55,
    y: 270.92,
    width: 144.09,
    height: 16.92,
    transform: "translate(-180.42 340.91) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.12,
    y: 338.88,
    width: 28.1,
    height: 1.9,
    transform: "translate(-233.66 397.55) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.51,
    y: 352.23,
    width: 28.1,
    height: 1.9,
    transform: "translate(-189.49 477.57) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.22,
    y: 366.39,
    width: 28.1,
    height: 1.9,
    transform: "translate(-142.61 562.51) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.08,
    y: 360.68,
    width: 28.1,
    height: 1.9,
    transform: "translate(-161.53 528.23) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.24,
    y: 232.76,
    width: 28.1,
    height: 1.9,
    transform: "translate(-113.02 330.96) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,354.68c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.9,1.83-8.83-.47,3-1,5.93-1.52,8.89L129.59,337l-1.73,8.85C127.27,348.8,126.67,351.74,126,354.68Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.58,355.16c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87-1.72,8.85C129.82,349.28,129.22,352.23,128.58,355.16Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.13,355.65c.47-3,1-5.93,1.52-8.89l1.63-8.87L136,329c.59-2.94,1.19-5.89,1.84-8.83-.48,3-1,5.94-1.52,8.9L134.7,338,133,346.82C132.37,349.76,131.77,352.71,131.13,355.65Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.68,356.13c.48-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.89,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87-1.73,8.85C134.93,350.25,134.33,353.19,133.68,356.13Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.23,356.61c.2-1.49.44-3,.68-4.46s.53-3,.8-4.44.57-2.95.88-4.42.64-2.94,1-4.4c-.19,1.5-.43,3-.68,4.46s-.53,3-.79,4.44-.57,2.95-.89,4.42S136.6,355.15,136.23,356.61Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.34,357.58c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-3,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.53,8.89l-1.63,8.87-1.73,8.85C142.58,351.7,142,354.64,141.34,357.58Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.89,358.07c.47-3,1-5.94,1.52-8.9l1.63-8.86,1.73-8.86c.59-2.94,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87-1.72,8.85C145.13,352.18,144.53,355.13,143.89,358.07Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.44,358.55c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.9,1.84-8.83-.47,3-1,5.93-1.52,8.89L150,340.87l-1.73,8.85C147.69,352.67,147.09,355.61,146.44,358.55Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,359c.48-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.6-2.95,1.19-5.89,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87-1.73,8.85C150.24,353.15,149.64,356.1,149,359Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.54,359.52c.2-1.5.44-3,.69-4.46s.52-3,.79-4.44.57-2.95.88-4.42.64-2.94,1-4.4c-.19,1.49-.43,3-.68,4.46s-.53,3-.79,4.44-.57,2.95-.89,4.42S151.91,358.06,151.54,359.52Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.65,360.48c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.94,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87-1.72,8.85C157.89,354.6,157.29,357.55,156.65,360.48Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.2,361c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.9,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.63,8.87L161,352.14C160.44,355.08,159.84,358,159.2,361Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.75,361.45c.48-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.89,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87-1.73,8.85C163,355.57,162.4,358.51,161.75,361.45Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.3,361.94c.2-1.5.44-3,.68-4.46s.53-3,.8-4.44.57-3,.88-4.43.64-2.94,1-4.4c-.19,1.5-.43,3-.68,4.46s-.53,3-.79,4.44-.58,2.95-.89,4.43S164.67,360.47,164.3,361.94Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.41,362.9c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-3,1.19-5.89,1.83-8.83-.47,3-1,5.93-1.52,8.89L173,345.22l-1.73,8.85C170.65,357,170.05,360,169.41,362.9Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,363.39c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.86c.59-2.94,1.19-5.89,1.84-8.83-.48,3-1,5.94-1.52,8.9l-1.64,8.86-1.72,8.86C173.2,357.5,172.6,360.45,172,363.39Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.51,363.87c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.63,8.87L176.35,355C175.75,358,175.15,360.93,174.51,363.87Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.06,364.35c.48-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.94,1.19-5.89,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87-1.73,8.85C178.31,358.47,177.71,361.42,177.06,364.35Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.61,364.84c.2-1.5.44-3,.68-4.46s.53-3,.8-4.44.57-2.95.88-4.42.64-2.94,1-4.4c-.19,1.49-.43,3-.68,4.46s-.53,3-.79,4.44-.57,3-.89,4.42S180,363.38,179.61,364.84Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.14,248.55c.48-3,1-5.93,1.53-8.89l1.63-8.87,1.72-8.85c.6-2.94,1.2-5.89,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87L148,239.72C147.39,242.67,146.79,245.62,146.14,248.55Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.7,249c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-3,1.19-5.9,1.84-8.83-.48,3-1,5.93-1.53,8.89l-1.63,8.87-1.73,8.85C149.94,243.16,149.34,246.1,148.7,249Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.25,249.52c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87-1.72,8.85C152.49,243.64,151.89,246.58,151.25,249.52Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.8,250c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.86c.59-2.94,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.63,8.87-1.73,8.86C155.05,244.12,154.45,247.07,153.8,250Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.35,250.49c.2-1.49.44-3,.68-4.46s.53-3,.79-4.44.58-3,.89-4.42.64-2.94,1-4.4c-.19,1.49-.43,3-.68,4.46s-.53,3-.79,4.44-.58,3-.89,4.42S156.72,249,156.35,250.49Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.46,251.46c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.9,1.83-8.84-.47,3-1,5.94-1.52,8.9L165,233.78l-1.73,8.85C162.7,245.57,162.1,248.52,161.46,251.46Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,251.94c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-3,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87-1.72,8.85C165.25,246.06,164.65,249,164,251.94Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.56,252.42c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.94,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87-1.72,8.85C167.8,246.54,167.2,249.49,166.56,252.42Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.11,252.91q.72-4.46,1.52-8.89l1.63-8.87L174,226.3c.59-3,1.19-5.9,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87L171,244.08C170.36,247,169.76,250,169.11,252.91Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.66,253.39c.2-1.49.44-3,.68-4.46s.53-3,.8-4.44.57-3,.88-4.42.64-2.94,1-4.4c-.19,1.49-.43,3-.68,4.46s-.53,3-.79,4.44-.58,3-.89,4.42S172,251.93,171.66,253.39Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.77,254.36c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.9,1.83-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87-1.73,8.85C178,248.48,177.41,251.42,176.77,254.36Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.32,254.84c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87L181.16,246C180.56,249,180,251.91,179.32,254.84Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.87,255.33c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.9,1.84-8.84-.48,3-1,5.94-1.52,8.9l-1.63,8.87-1.73,8.85C183.11,249.44,182.51,252.39,181.87,255.33Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.42,255.81c.2-1.49.44-3,.68-4.46s.53-3,.79-4.44.58-2.95.89-4.42.63-2.94,1-4.4c-.19,1.49-.43,3-.68,4.46s-.53,3-.79,4.44-.58,2.95-.89,4.42S184.79,254.35,184.42,255.81Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,256.78c.48-3,1-5.93,1.53-8.89l1.63-8.87,1.72-8.85c.6-2.95,1.2-5.9,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87L191.36,248C190.77,250.9,190.17,253.84,189.52,256.78Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.08,257.26c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-3,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.53,8.89l-1.63,8.87-1.73,8.85C193.32,251.38,192.72,254.32,192.08,257.26Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.63,257.75c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.86c.59-2.94,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87-1.72,8.86C195.87,251.86,195.27,254.81,194.63,257.75Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.18,258.23c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-3,1.19-5.9,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87L199,249.4C198.43,252.35,197.83,255.29,197.18,258.23Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.73,258.71c.2-1.49.44-3,.68-4.46s.53-3,.79-4.44.58-2.95.89-4.42.64-2.94,1-4.4c-.19,1.5-.43,3-.68,4.46s-.53,3-.79,4.44-.58,3-.89,4.42S200.1,257.25,199.73,258.71Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.99,
    y: 331.25,
    width: 56.59,
    height: 2.63,
    transform: "translate(-158.88 473.29) rotate(-79.27)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.37,
    y: 338.95,
    width: 40.91,
    height: 2.63,
    transform: "translate(-167.64 478.12) rotate(-79.27)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.67,
    y: 332.52,
    width: 56.59,
    height: 2.63,
    transform: "translate(-154.69 480.88) rotate(-79.27)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.58,
    y: 334.82,
    width: 51.89,
    height: 2.63,
    transform: "matrix(0.19, -0.98, 0.98, 0.19, -157.32, 482.33)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.34,
    y: 333.78,
    width: 56.59,
    height: 2.63,
    transform: "translate(-150.5 488.47) rotate(-79.27)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.42,
    y: 339.92,
    width: 44.1,
    height: 2.63,
    transform: "translate(-157.48 492.32) rotate(-79.27)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.02,
    y: 335.05,
    width: 56.59,
    height: 2.63,
    transform: "translate(-146.31 496.07) rotate(-79.27)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.26,
    y: 338.96,
    width: 48.63,
    height: 2.63,
    transform: "translate(-150.76 498.52) rotate(-79.27)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.7,
    y: 336.31,
    width: 56.59,
    height: 2.63,
    transform: "translate(-142.12 503.66) rotate(-79.27)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.07,
    y: 337.97,
    width: 53.22,
    height: 2.63,
    transform: "translate(-144 504.7) rotate(-79.27)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.72,
    y: 364.39,
    width: 4.24,
    height: 4.24,
    transform: "translate(-197.48 494.6) rotate(-79.27)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 365.66,
    width: 4.24,
    height: 4.24,
    transform: "translate(-193.29 502.19) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.08,
    y: 366.92,
    width: 4.24,
    height: 4.24,
    transform: "translate(-189.1 509.78) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.76,
    y: 368.19,
    width: 4.24,
    height: 4.24,
    transform: "translate(-184.91 517.37) rotate(-79.27)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.44,
    y: 369.46,
    width: 4.24,
    height: 4.24,
    transform: "translate(-180.72 524.96) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.22,
    y: 269.48,
    width: 36.06,
    height: 1.9,
    transform: "translate(-95.43 425.65) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.56,
    y: 281.84,
    width: 13.71,
    height: 1.9,
    transform: "translate(-103.36 440.78) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.47,
    y: 284.85,
    width: 13.71,
    height: 1.9,
    transform: "translate(-93.38 458.86) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.37,
    y: 287.87,
    width: 13.71,
    height: 1.9,
    transform: "translate(-83.4 476.93) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.27,
    y: 290.88,
    width: 13.71,
    height: 1.9,
    transform: "translate(-73.43 495.01) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3,262.32c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-3,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87-1.72,8.85C219.54,256.44,218.94,259.39,218.3,262.32Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.85,262.81c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.9,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.63,8.87L222.69,254C222.09,256.92,221.49,259.87,220.85,262.81Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.4,263.29c.48-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-3,1.19-5.89,1.84-8.83-.47,3-1,5.93-1.52,8.89L227,245.61l-1.73,8.85C224.65,257.41,224.05,260.35,223.4,263.29Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,263.77c.15-1.26.35-2.51.55-3.77s.45-2.5.67-3.75.48-2.49.75-3.73.55-2.49.87-3.72c-.15,1.27-.35,2.52-.55,3.78s-.44,2.5-.66,3.75-.49,2.49-.76,3.73S226.27,262.54,226,263.77Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.24,265.35c.48-3,1-5.93,1.52-8.89l1.64-8.87,1.72-8.86c.6-2.94,1.2-5.89,1.84-8.83-.47,3-1,5.94-1.52,8.9l-1.63,8.86-1.73,8.86C235.49,259.46,234.89,262.41,234.24,265.35Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,265.83c.48-3,1-5.93,1.53-8.89l1.63-8.87,1.72-8.85c.6-2.95,1.2-5.89,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87L238.63,257C238,260,237.44,262.89,236.79,265.83Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.35,266.31c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87-1.73,8.85C240.59,260.43,240,263.38,239.35,266.31Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.9,266.8c.15-1.27.35-2.52.55-3.78s.44-2.5.66-3.75.49-2.49.76-3.73.54-2.48.87-3.71c-.15,1.26-.35,2.51-.55,3.77s-.45,2.5-.67,3.75-.48,2.49-.75,3.73S242.22,265.57,241.9,266.8Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19,268.37c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.9,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87L252,259.54C251.43,262.49,250.83,265.43,250.19,268.37Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.74,268.85c.48-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-3,1.19-5.89,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87L254.58,260C254,263,253.39,265.92,252.74,268.85Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.29,269.34c.48-3,1-5.93,1.52-8.89l1.64-8.87,1.72-8.85c.6-2.95,1.2-5.9,1.84-8.84-.47,3-1,5.94-1.52,8.9l-1.63,8.86-1.73,8.86C256.54,263.45,255.94,266.4,255.29,269.34Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.84,269.82c.16-1.26.35-2.52.56-3.77s.44-2.5.66-3.75.48-2.5.75-3.74.55-2.48.87-3.71c-.15,1.26-.34,2.52-.55,3.77s-.44,2.5-.66,3.75-.49,2.5-.76,3.74S258.17,268.59,257.84,269.82Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.13,271.39c.48-3,1-5.93,1.53-8.89l1.63-8.87,1.72-8.85c.6-2.95,1.2-5.89,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87L268,262.56C267.38,265.51,266.78,268.45,266.13,271.39Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.69,271.88c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.86c.59-2.94,1.19-5.89,1.84-8.83-.48,3-1,5.93-1.53,8.89l-1.63,8.87-1.73,8.86C269.93,266,269.33,268.94,268.69,271.88Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.24,272.36c.47-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.59-2.95,1.19-5.9,1.84-8.83-.48,3-1,5.93-1.52,8.89l-1.64,8.87-1.72,8.85C272.48,266.48,271.88,269.42,271.24,272.36Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79,272.84c.15-1.26.35-2.52.55-3.77s.44-2.5.66-3.75.49-2.49.76-3.74.55-2.48.87-3.71c-.15,1.27-.35,2.52-.55,3.77s-.44,2.51-.66,3.76-.49,2.49-.76,3.73S274.11,271.61,273.79,272.84Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.31 269.3 224.39 270.72 232.45 272.19 248.57 275.19 249.55 275.43 257.59 277.01 265.62 278.65 257.55 277.23 249.48 275.76 248.48 275.63 232.39 272.52 224.35 270.93 216.31 269.3",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.11,268.59a.85.85,0,1,1-1,.68A.86.86,0,0,1,217.11,268.59Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05,271.62a.84.84,0,0,1,.68,1,.86.86,0,0,1-1,.68.84.84,0,0,1-.67-1A.83.83,0,0,1,233.05,271.62Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,274.64a.84.84,0,0,1-.31,1.66.86.86,0,0,1-.68-1A.84.84,0,0,1,249,274.64Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,277.66a.85.85,0,1,1-1,.67A.85.85,0,0,1,265,277.66Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87,365.42a6.24,6.24,0,1,1-3.21.23A6.25,6.25,0,0,1,249.87,365.42Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.66,365.65l2.05,5.92-6.15-1.17A6.25,6.25,0,0,1,246.66,365.65Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51,367.32a4.33,4.33,0,1,1-5.06,3.44A4.32,4.32,0,0,1,249.51,367.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.21,
    y: 371.18,
    width: 3.6,
    height: 0.51,
    transform: "translate(-163.12 545.92) rotate(-79.26)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.71,
    y: 371.44,
    width: 5.39,
    height: 0.51,
    transform: "translate(-162.25 547.5) rotate(-79.26)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.13,348.22a5,5,0,0,1,.89.23,6.26,6.26,0,1,1-4.1,0A6.1,6.1,0,0,1,253.13,348.22Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.13,348.22a5,5,0,0,1,.89.23L252,354.36l-6.15-1.16a6.25,6.25,0,0,1,4.1-4.75A6.1,6.1,0,0,1,253.13,348.22Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.77,350.11a4.33,4.33,0,1,1-5.06,3.45A4.34,4.34,0,0,1,252.77,350.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.47,
    y: 353.98,
    width: 3.6,
    height: 0.51,
    transform: "translate(-143.56 535.13) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.97,
    y: 354.24,
    width: 5.39,
    height: 0.51,
    transform: "translate(-142.69 536.71) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.42,330.89a6.28,6.28,0,1,1-3.21.24A6.18,6.18,0,0,1,256.42,330.89Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.42,330.89a6.27,6.27,0,0,1,5,5L255.25,337l-6.15-1.16a6.26,6.26,0,0,1,4.11-4.75A6.18,6.18,0,0,1,256.42,330.89Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,332.79a4.33,4.33,0,1,1-5.06,3.45A4.32,4.32,0,0,1,256.06,332.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.75,
    y: 336.66,
    width: 3.6,
    height: 0.51,
    transform: "translate(-123.87 524.26) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.25,
    y: 336.92,
    width: 5.39,
    height: 0.51,
    transform: "translate(-123 525.84) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.68,313.67a6.24,6.24,0,1,1-3.21.23A6.1,6.1,0,0,1,259.68,313.67Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.68,313.67a6.26,6.26,0,0,1,2.76,11l-3.92-4.88-6.15-1.16a6.25,6.25,0,0,1,4.1-4.75A6.1,6.1,0,0,1,259.68,313.67Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.32,315.56a4.33,4.33,0,1,1-5.06,3.45A4.34,4.34,0,0,1,259.32,315.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.02,
    y: 319.43,
    width: 3.6,
    height: 0.51,
    transform: "translate(-104.29 513.45) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.52,
    y: 319.69,
    width: 5.39,
    height: 0.51,
    transform: "translate(-103.42 515.03) rotate(-79.27)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.06 297.24 211.49 298.73 219.91 300.26 236.73 303.4 253.54 306.64 261.94 308.29 270.33 309.99 261.9 308.5 253.48 306.96 236.65 303.82 219.85 300.58 211.45 298.93 203.06 297.24",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--iaq7yo--inject-285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.81,379.14a.74.74,0,0,1,.08.3v.13l0,.24-.09.22a2.45,2.45,0,0,1-.53.78,5.68,5.68,0,0,1-1.8,1.22,2.57,2.57,0,0,1-.91.21h-.25l-.22,0-.21-.09-.17-.14,0,0,1.14-.77a0,0,0,0,1,.06,0,.48.48,0,0,0,.48,0,10.36,10.36,0,0,0,1-.7.46.46,0,0,0,.19-.45.06.06,0,0,1,0-.05l1.16-.78Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.35,378.48c.1.13.19.27.28.4l0,0-1.17.79-.05-.09-.24-.34a.16.16,0,0,1,.05-.25l.87-.59A.15.15,0,0,1,275.35,378.48Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.38,380.49l.29.45-1.15.78a0,0,0,0,0,0,0c-.09-.14-.18-.28-.28-.41a.16.16,0,0,1,0-.24l.88-.6A.15.15,0,0,1,272.38,380.49Z",
    style: {
      fill: "#efefef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tefye6--inject-285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.85,379.66l.08.12,1.24,1.93a.25.25,0,0,1-.07.38l-1.9,1.37-.08.06a.3.3,0,0,1,0-.16l.21-1.13c.15-.79.3-1.58.44-2.37A.4.4,0,0,1,280.85,379.66Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.74,380.21a.75.75,0,0,1,0,.15c-.08.45-.17.9-.25,1.36-.13.72-.27,1.45-.4,2.18a.65.65,0,0,1-.08.17l-1-1.6.3-.22.13-.09a.29.29,0,0,0,.07-.41l-.27-.43,1.53-1.11Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.79,382.6c.34.52.67,1,1,1.57h-.07l-2.39-.44-.07,0Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.58,380l-.57.41-.91.66,0,0-1-1.56C281.1,379.55,283.52,380,283.58,380Z",
    style: {
      fill: "#efefef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--aizgp2--inject-285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.22,312.85a3.05,3.05,0,0,0,.91.39h0c-.06.27-.11.54-.16.82h0l-.07,0a2.08,2.08,0,0,1-.32-.12,2.31,2.31,0,0,1-.48-.28v0l.15-.77Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.33,313.28h0l-.15.76h0a2.15,2.15,0,0,1-.62.08h-.33l.15-.81s0,0,0,0l.2,0h.33l.4,0Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.19,310.08h0a2,2,0,0,1,.24.27,2.14,2.14,0,0,1,.23.38,2.05,2.05,0,0,1,.16.41,1.86,1.86,0,0,1,.08.41c0,.11,0,.22,0,.33V312h0v0a2.52,2.52,0,0,0-.48-.72,2.82,2.82,0,0,0-.36-.33s0,0,0,0l.15-.77Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.63,310.59l-.21,1.08-.94-.18h0c0-.28.11-.56.16-.84h0a2.38,2.38,0,0,1,.59-.07l.31,0Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.88,310.64l.07,0,.15,0,.21.08a2.64,2.64,0,0,1,.44.23s0,0,0,0c-.06.28-.11.57-.17.85v0l-.91-.18Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.44,311.73l.95.18-.21,1.06-.07,0-.15-.05a.92.92,0,0,1-.23-.09,1.88,1.88,0,0,1-.44-.24s0,0,0,0c.05-.27.1-.53.16-.8Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.64,312l.89.17h0v0l-.15.83h0a2.07,2.07,0,0,1-.5.06h-.26l-.17,0h0v0c.07-.34.13-.68.2-1C286.63,312,286.63,312,286.64,312Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,309.44l-.16.89a3,3,0,0,0-1,0h0l.15-.81,0,0a2.18,2.18,0,0,1,.63-.09,2,2,0,0,1,.34,0Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.09,309.48l.06,0,.24.07a2.42,2.42,0,0,1,.5.27l.07.05h0l-.15.82h0l-.08-.05a2.57,2.57,0,0,0-.41-.19l-.31-.1-.08,0s0,0,0,0h0Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.58,309.61h0c0,.26-.09.51-.14.77a0,0,0,0,1,0,0,3,3,0,0,0-.64.28,2,2,0,0,0-.33.24l-.15.14h0a2.44,2.44,0,0,1,1.31-1.47Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.79,312.52v0a2.44,2.44,0,0,1-.1.24,2.22,2.22,0,0,1-.25.42,2.11,2.11,0,0,1-.39.4,1.94,1.94,0,0,1-.33.23,1.69,1.69,0,0,1-.27.12h0c0-.24.09-.48.13-.72l0,0a2,2,0,0,0,.48-.18,2.5,2.5,0,0,0,.41-.25,2.26,2.26,0,0,0,.29-.25Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.18,311.66l.06.13c.08.14.17.28.26.41a2.5,2.5,0,0,0,.46.46l0,0h0a.08.08,0,0,0,0,0l-.14.71a2.33,2.33,0,0,1-.68-1.78h0Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,311.18a2.24,2.24,0,0,1,.42.45,2.4,2.4,0,0,1,.27.47l-.83-.16Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.79,312.18l.82.15a2.32,2.32,0,0,1-1,.58Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.37,310.71l-.14.73-.77-.15a2.72,2.72,0,0,1,.42-.34A2.47,2.47,0,0,1,285.37,310.71Z",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,311.54l.75.15-.13.7A2.2,2.2,0,0,1,284.44,311.54Z",
    style: {
      fill: "#efefef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ugja8c--inject-285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.83,311.31a2,2,0,0,0-1.5,2.09,1.89,1.89,0,0,0,1.7,1.81,2.55,2.55,0,0,0,.91-.1,6.43,6.43,0,0,0,1.82-.8c.23-.14.46-.3.69-.45,0,0,0-.05,0-.07-.21-.29-.41-.58-.64-.86a5.7,5.7,0,0,0-1.46-1.35A1.89,1.89,0,0,0,293.83,311.31Zm.61.72a1.24,1.24,0,0,1,.92,1.49,1.22,1.22,0,1,1-2.37-.58A1.24,1.24,0,0,1,294.44,312Z",
    style: {
      fill: "#efefef"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.36,373.59c.48-3,1-5.93,1.52-8.89l1.64-8.87,1.72-8.85c.6-3,1.2-5.89,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87-1.73,8.85C274.61,367.71,274,370.66,273.36,373.59Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.92,374.08c.19-1.5.43-3,.68-4.46s.53-3,.79-4.44.57-2.95.89-4.42.63-2.94,1-4.4c-.19,1.49-.43,3-.68,4.46s-.52,3-.79,4.44-.57,2.95-.89,4.42S276.28,372.62,275.92,374.08Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.86,375.2c.48-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.6-2.94,1.2-5.89,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87-1.73,8.85C283.11,369.32,282.51,372.27,281.86,375.2Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.41,375.69c.2-1.5.44-3,.69-4.46s.52-3,.79-4.44.57-3,.88-4.42.64-2.94,1-4.4c-.19,1.49-.43,3-.68,4.46s-.53,3-.79,4.44-.57,2.95-.89,4.42S284.78,374.23,284.41,375.69Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.76,302.91c.48-3,1-5.93,1.52-8.89l1.64-8.87,1.72-8.85c.6-2.95,1.2-5.9,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87-1.73,8.85C288,297,287.41,300,286.76,302.91Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.32,303.39c.19-1.49.43-3,.68-4.46s.53-3,.79-4.44.57-2.95.89-4.42.63-2.94,1-4.4c-.19,1.49-.43,3-.68,4.46s-.52,3-.79,4.44-.57,2.95-.89,4.42S289.68,301.93,289.32,303.39Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.26,304.52c.48-3,1-5.93,1.52-8.89l1.63-8.87,1.73-8.85c.6-3,1.2-5.9,1.84-8.83-.47,3-1,5.93-1.52,8.89l-1.63,8.87-1.73,8.85C296.51,298.64,295.91,301.58,295.26,304.52Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.81,305c.2-1.49.44-3,.69-4.46s.52-3,.79-4.44.57-3,.88-4.42.64-2.94,1-4.4c-.19,1.5-.43,3-.68,4.46s-.53,3-.79,4.44-.57,2.95-.89,4.42S298.18,303.54,297.81,305Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.24 423.89 84.36 423.89 54.89 266.77 290.77 266.77 320.24 423.89",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.41 250.5 51.84 250.5 54.89 266.77 147.5 266.77 139.41 250.5",
    style: {
      fill: "#efefef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-285"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.15,
    y: 148.9,
    width: 11.06,
    height: 64.54,
    transform: "translate(43.93 381.18) rotate(-133.59)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.77 219.99 62.3 232.1 62.3 232.1 94.95 201.03 94.95 201.03 83.42 188.91 83.42 188.91 50.77 219.99",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.56,118a50.4,50.4,0,1,1,41.32,58.07A50.45,50.45,0,0,1,111.56,118Zm5.7,1a44.62,44.62,0,1,0,51.41-36.58A44.66,44.66,0,0,0,117.26,119Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,176.41a52.09,52.09,0,1,1,16.3-7.78A51.5,51.5,0,0,1,175,176.41Zm-26.76-97.2a49.41,49.41,0,0,0-15.35,7.33,48.57,48.57,0,1,0,15.35-7.33Zm25.23,91.63a46.14,46.14,0,0,1-57.72-52.14h0A46.12,46.12,0,1,1,188,163.93,46.39,46.39,0,0,1,173.5,170.84ZM118.74,119.2a43.16,43.16,0,1,0,17.53-27.95,43.15,43.15,0,0,0-17.53,28Z",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.31,83.51a42.87,42.87,0,1,0,41.81,43.92A42.87,42.87,0,0,0,162.31,83.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.26,84.92A42.95,42.95,0,0,0,119.7,137Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,96.45l-41.85,71.33a42.87,42.87,0,0,0,10.07,1.45,41.92,41.92,0,0,0,11.59-1.3l30.9-52.65A42.86,42.86,0,0,0,192,96.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.58,83.83l-39.87,67.94a43.93,43.93,0,0,0,5.63,6.25l42.45-72.34A42,42,0,0,0,166.58,83.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.59,92.54l-43,73.33c.48.2,1,.4,1.45.58L188.8,93.52C188.41,93.19,188,92.85,187.59,92.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,129.58l-19.09,32.54a38,38,0,0,0,3.11-2.27l15.53-26.47C203.77,132.14,203.92,130.87,204,129.58Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.49,118.71a34.61,34.61,0,0,1,5.44-12.93,36.72,36.72,0,0,1,4.55-5.5,38,38,0,0,1,5.6-4.51,33.91,33.91,0,0,1,13.38-5,37,37,0,0,1,14,.65,65.76,65.76,0,0,0-13.56,1.65,40.64,40.64,0,0,0-6.34,2.11,34.48,34.48,0,0,0-5.86,3.09,42.92,42.92,0,0,0-9.91,8.89A57.82,57.82,0,0,0,127.49,118.71Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDatagrid);
export default __webpack_public_path__ + "static/media/emptyDatagrid.a99110d9756ecc51acaeaec485f994d3.svg";
export { ForwardRef as ReactComponent };